import { postUserDescription } from '../api/postUserDescription';
import {setGetUserById} from './setGetUserById';

export const setPostUserDescription = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUserDescription(params);
            dispatch(setGetUserById(params.id));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}